// src/components/WhatsAppButton.js
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';
import { useTranslation } from 'react-i18next';

const WhatsAppButton = () => {
  const { t } = useTranslation();

  const phoneNumber = '17875453020';

  const handleClick = () => {
    const message = t('whatsapp_message');
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, '_blank');
  };

  return (
    <button
      className="whatsapp-float"
      onClick={handleClick}
      aria-label={t('whatsapp_aria')}
    >
      <FaWhatsapp size={30} />
    </button>
  );
};

export default WhatsAppButton;
